import { useCallback, useRef } from 'react'

import { IDomainEvent, ISocketService, ISocketServiceProps, SocketService } from './SocketService'

export type SocketState = {
  initializeSocket: (props: ISocketServiceProps) => void
  createDomainEventsListeners: (domainEvents: IDomainEvent[]) => void
  disconnectSocket: () => void
}

export const useSocket = (): SocketState => {
  // Using a ref to prevent rerenders
  const socketServiceRef = useRef<ISocketService | undefined>(undefined)

  const initializeSocket = useCallback(({ token, params, nameSpace }: ISocketServiceProps): void => {
    socketServiceRef.current = new SocketService({
      token,
      nameSpace,
      params: {
        ...(params || {}),
      },
    })
  }, [])

  const createDomainEventsListeners = useCallback((domainEvents: IDomainEvent[]): void => {
    if (socketServiceRef.current) {
      socketServiceRef.current.createDomainEventsListeners(domainEvents)
    } // TODO: else?
  }, [])

  const disconnectSocket = useCallback((): void => {
    if (socketServiceRef.current) {
      socketServiceRef.current.disconnect()
    } // TODO: else?
  }, [])

  return { initializeSocket, createDomainEventsListeners, disconnectSocket }
}
